import { initArtifactsTable } from '~/ci/artifacts/index';

initArtifactsTable();
